// eslint-disable-next-line import/no-cycle
import request from '@/plugins/axios';

/**
 * @description 获取用户购买了的训练营和精品课
 * @param {object} data
 * @param {number} [data.type=0] 0训练营，1精品课
 * @param {number} [data.offset=0] 偏移量
 * @param {number} [data.limit=20] 每页条数
 * @param {number} [data.sort=0] 排序方式，0更新时间，1购买时间，2学习时间
 * @returns {Promise}
 */
export const getUserLesson = data => request({
  method: 'get',
  url: '/api/content/study/lesson_record_v3_8',
  params: data
});

/**
 * @description 获取首页的精品课列表
 * @returns {Promise}
 */
export const getCourseList = () => request({
  method: 'get',
  url: '/api/lesson/series/query_new',
  params: {
    offset: 0,
    limit: 6,
    is_training: 0,
    state: 2
  }
});

/**
 * @description 获取精品课课程分类列表
 * @returns {Promise}
 */
export const getCourseTypes = () => request({
  method: 'get',
  url: '/api/lesson/h5/get_lesson_labels'
});

/**
 * @description 获取精品课列表
 * @param {object} data
 * @param {number} [data.limit=10] 每页条数
 * @param {number} [data.offset=0] 偏移量
 * @param {number} [data.sort=0] 排序方式，0时间，1热度
 * @param {string} [data.lesson_label] 分类名称，默认全部
 * @returns {Promise}
 */
export const getQualityCourseList = data => request({
  method: 'get',
  url: '/api/lesson/h5/get_excellent_lesson',
  params: data
});
